import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ContactAndSafetyInfo from "../contactAndSafetyInfo";
import { TextAlignProps } from "../contactAndSafetyInfo/types";
import { AuthContext } from "src/context/authContext";
import {HCPUserSubHeaderProps} from "../../types/users";

const AuthSubHeader: FC = (): JSX.Element => {
  const [repInfo, setRepInfo] = useState<[string[], string[]]>([[], []]);

  const navigate = useNavigate();
  const { isManufacturer, sub_header } = useContext(AuthContext);

  useEffect(() => {
    if (isManufacturer || !sub_header) {
      setRepInfo([[], []]);
      return;
    }

    const subHeaderData = (sub_header as HCPUserSubHeaderProps).rep_data?.reduce((acc, curr) => {
      acc[0].push(curr.Rep);
      acc[1].push(curr.Email);
      return acc;
    }, [[], []] as [string[], string[]]);

    setRepInfo(subHeaderData || [[], []]);
  }, [isManufacturer, sub_header]);

  return (
    <div className="row pt-4">
      <div className="col-12 col-lg-3 text-left">
        {!isManufacturer && (
          <>
            <p className="mb-0">
              <b>Rep:</b> {repInfo[0].map((rep, index) => (
                <span key={index}>
                  {rep}
                  {index !== repInfo.length - 1 && ", "}
                </span>
              ))}
            </p>
            <p className="mb-0">
              <b>Email:{' '}</b>
              {repInfo[1].map((email, index) => (
                <a href={`mailto:${email}`} key={index}>
                  {email}
                  {index !== repInfo[1].length - 1 && ", "}
                </a>
              ))}
            </p>
          </>
        )}
      </div>

      <div className="col-12 col-lg-4 text-center">
        {!isManufacturer && (
          <button className="btn btn-primary rounded-0 mb-2 mb-lg-0" onClick={() => navigate(`/rep_visits/new`)} style={{minWidth:'336px'}}>
            <i className="bi-calendar-week-fill pe-1 text-light" style={{color: 'white'}}></i> Schedule a Rep
            Visit
          </button>
        )}
      </div>
      <div className="col-12 col-lg-5">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END}/>
      </div>
    </div>
  );
};

export default AuthSubHeader;
